import { useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Flag, Search, Check } from "lucide-react";

export function KickoffPanel() {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (apply) => {
    if (apply && !window.confirm("Aplicar o arranque da edição? Os registos listados são apagados definitivamente.")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/edition-kickoff", { apply });
      setR(data);
      if (apply) toast.success("Edição alinhada — tudo a zeros e coerente");
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  const nothing = r && !r.edition_start_stale && !r.since_fix.length && !r.early_entries.length;
  return (
    <div className="kw-card p-6 space-y-4" data-testid="kickoff-panel">
      <div className="flex items-center gap-2">
        <Flag className="w-5 h-5 text-[#E50000]" />
        <h3 className="font-display text-xl font-black uppercase">Arranque da edição</h3>
      </div>
      <p className="text-sm text-[#A3A3A3]">
        Verifica e corrige dados criados antes do início: alinha a edição com a data de início, põe todos os coopetidores
        a contar desde a 1.ª semana e apaga registos semanais feitos antes do arranque. Primeiro só mostra o que mudaria.
      </p>
      <button onClick={() => run(false)} disabled={busy} className="kw-btn-secondary text-xs inline-flex items-center gap-2"
        data-testid="kickoff-check"><Search className="w-4 h-4" /> Verificar</button>
      {r && (
        <div className="text-sm space-y-2" data-testid="kickoff-report">
          {nothing && <div className="text-[#22C55E] flex items-center gap-2"><Check className="w-4 h-4" /> Está tudo coerente.</div>}
          {r.edition_start_stale && <div>• A edição guardada começa a <b>{r.edition_start_stored}</b> — passa para <b>{r.start_date}</b>.</div>}
          {r.since_fix.length > 0 && <div>• <b>{r.since_fix.length}</b> coopetidor(es) passam a contar desde a S{r.since_fix[0].to}
            <span className="text-[#737373]"> ({r.since_fix.map((x) => x.name).join(", ")})</span></div>}
          {r.early_entries.length > 0 && (
            <div>• <b>{r.early_entries.length}</b> registo(s) anteriores ao início serão apagados:
              {r.early_entries.map((e, i) => <div key={i} className="text-[#A3A3A3] pl-3">{e.name} · S{e.week} · {e.points} pts</div>)}
            </div>
          )}
          {r.applied && <div className="text-[#22C55E]">Aplicado.</div>}
          {!nothing && !r.applied && (
            <button onClick={() => run(true)} disabled={busy} className="kw-btn-primary text-xs" data-testid="kickoff-apply">Aplicar correções</button>
          )}
        </div>
      )}
    </div>
  );
}
